import { render, staticRenderFns } from "./MenuBarDefault.vue?vue&type=template&id=21b0f86d&"
import script from "./MenuBarDefault.vue?vue&type=script&lang=js&"
export * from "./MenuBarDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports